import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warehouse1",
  "use": "warehouse1-usage",
  "viewBox": "0 0 20 23",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 23\" id=\"warehouse1\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.992.5a9.593 9.593 0 0 1 2.623 18.823A64.802 64.802 0 0 1 9.993 22.5a64.805 64.805 0 0 1-2.623-3.177C3.347 18.182.4 14.481.4 10.093A9.593 9.593 0 0 1 9.992.5Z\" fill=\"#3A5494\" /><path d=\"M10 14.1a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol